import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import history from "~/history";
import * as featuresActions from "~/store/features/featuresActions";
import {
  requestHospitalList,
  resetFeatureListByHospital,
  setHospitalFilter,
  selectHospital as selectHospitalActions,
  selectHospitalBefore,
  switchSelectFlow
} from "~/store/hospital/hospitalActions";
import * as rebooking from "~/store/rebooking/rebookingAction";
import { requestAllCity } from "~/store/resource/resourceAction";
import {
  resetData,
  selectHospital as selectHospitalTotalData,
  getExtraConfig
} from "~/store/totalData/actions";
import { postInfoXNC, getPatientList } from "~/store/patient/patientAction";
import { listAppId } from "~/utils/constants";
import AppId from "~/utils/partner";

const Desktop = Loadable({
  loader: () => import("~/components/desktop/pages/ChooseHospital"),
  loading: LoadableLoading
});

class ChooseHospital extends Component {
  componentWillMount() {
    if (!listAppId.includes(AppId)) {
      history.push("/");
    }
  }

  componentDidMount() {
    this.props.clearFollowupState();
    this.props.resetFeatureListByHospital();
    this.props.resetData();
    this.props.requestAllCity();

    // Clear active hospital booking selection
    this.props.selectHospital(null);
    this.props.selectHospitalBefore(null);
    this.props.switchSelectFlow(false);
  }

  render() {
    return (
      <Fragment>
        <Desktop {...this.props} {...this.methods} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: {
      selectedHospital,
      featureList: { data: featureList },
      hospitalList: { data: hospitalList, total: hospitalListTotal },
      hospitalFilter
    },
    features: { selectedFeature, featureListBooking },
    user: { IsAuthenticated },
    resource: { dataCity: allCities },
    totalData: { loading, typeAction }
  } = state;
  return {
    loading,
    device: type,
    selectedHospital,
    selectedFeature,
    IsAuthenticated,
    featureList,
    featureListBooking,
    hospitalList,
    hospitalListTotal,
    allCities,
    hospitalFilter,
    typeAction
  };
};

const mapDispatchToProps = dispatch => ({
  clearFollowupState: () => dispatch(rebooking.clearState()),
  resetFeatureListByHospital: () => {
    dispatch(resetFeatureListByHospital());
  },
  selectFeatureBookingById: id =>
    dispatch(featuresActions.selectFeatureBookingById(id)),

  requestHospitalList: params => {
    dispatch(requestHospitalList(params));
  },
  resetData: () => {
    dispatch(resetData());
  },
  requestAllCity: () => {
    dispatch(requestAllCity());
  },
  setHospitalFilter: filter => {
    dispatch(setHospitalFilter(filter));
  },
  selectPartner: (id, hospital) =>
    dispatch(selectHospitalTotalData(id, hospital)),
  selectHospital: id => dispatch(selectHospitalActions(id)),
  selectHospitalBefore: id => dispatch(selectHospitalBefore(id)),
  switchSelectFlow: status => dispatch(switchSelectFlow(status)),
  requestAllFeatures: () => dispatch(featuresActions.requestAllFeatures()),
  getExtraConfig: id => dispatch(getExtraConfig(id)),
  postInfoXNC: info => dispatch(postInfoXNC(info)),
  getPatientList: () => dispatch(getPatientList())
});

const ChooseHospitalHelmet = withTitle({
  component: ChooseHospital,
  title: "Medpro | Chọn bệnh viện"
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChooseHospitalHelmet)
);
